import { setIframeSrcDoc } from 'polyfills/helpers';

// eslint-disable-next-line import/prefer-default-export
export const setupIframeForApi = (
  iframeId: string,
  iframeStyles: string,
  content: string,
  iframeTitle: string,
): undefined => {
  const scriptEmbedElement = document.querySelectorAll(
    '[data-kustomer-api-key]',
  )[0] as HTMLScriptElement | null;

  if (!scriptEmbedElement || !scriptEmbedElement.parentNode) return;

  const iframe = document.createElement('iframe');

  iframe.setAttribute('id', iframeId);
  iframe.setAttribute('title', iframeTitle);

  iframe.style.cssText = iframeStyles;

  scriptEmbedElement.parentNode.insertBefore(iframe, scriptEmbedElement);

  setIframeSrcDoc(iframe, content);
};

export const getIframeForWidgetMain = (): HTMLIFrameElement | undefined => {
  const iframe = document.getElementById(
    'kustomer-ui-sdk-iframe',
  ) as HTMLIFrameElement;

  if (!iframe) return undefined;

  return iframe;
};

export const getIframeForCoreApi = (): HTMLIFrameElement | undefined => {
  const iframe = document.getElementById(
    'kustomer-core-sdk-iframe',
  ) as HTMLIFrameElement;

  if (!iframe) return undefined;

  return iframe;
};

export const setTrackingTokenInLocalStorage = (token) => {
  try {
    localStorage.setItem('kustomer-chat-tracking-token', token);
  } catch {
    throw new Error('Setting tracking token in local storage');
  }
};

export const getTrackingTokenFromLocalStorage = () => {
  try {
    return localStorage.getItem('kustomer-chat-tracking-token');
  } catch {
    throw new Error('Getting tracking token from local storage');
  }
};

export const removeTrackingTokenFromLocalStorage = () => {
  try {
    return localStorage.removeItem('kustomer-chat-tracking-token');
  } catch {
    throw new Error('Removing tracking token from local storage');
  }
};
